<template>
  <v-container fluid>
    <v-row class="mb-5" no-gutters>
      <v-col cols="12">
        <v-card :elevation="1">
          <v-data-table class="analysis" :headers="this.totalHeaders" :items="this.totalItems" :loading="loading" loading-text="データ取得中" hide-default-header hide-default-footer disable-sort :mobile-breakpoint="1200" dense>
            <template slot="top">
              <v-toolbar flat>
                  <v-toolbar-title>総計</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field v-model="search" @input="textSearch(search)" class="mr-2" prepend-icon="mdi-card-search-outline" label="検索" single-line hide-details></v-text-field>
                  <v-btn depressed small @click.stop="searchDialogDrawer=true" color="success">検索</v-btn>
              </v-toolbar>
              <v-divider/>
            </template>
            <template v-slot:header>
              <thead>
                <tr>
                  <th v-for="header in totalUpperHeaders" :key="header.value" :rowspan="header.row || 1" :colspan="header.col || 1">
                      <div>
                          {{ header.text }}
                      </div>
                  </th>
                </tr>
                <tr>
                  <th v-for="header in totalBottomHeaders" :key="header.value" :rowspan="header.row || 1" :colspan="header.col || 1">
                      <div>
                          {{ header.text }}
                      </div>
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:item="{ item, headers }">
              <!-- 1行目 -->
              <tr>
                  <td v-for="header in totalHeaders" :key="header.value" :style="{ 'color' : minusCheck(item[header.value].value) ? 'red' : '', 'text-align' : header.align, 'background-color' : 'white' }" :rowspan="item[header.value].row || 1" >
                      <div v-if="header.isStep">
                          {{ replaceSpace(item[header.value].value.upper) }}
                      </div>
                      <div v-else>
                          {{ replaceSpace(item[header.value].value) }}
                      </div>
                  </td>
              </tr>
              <!-- 2行目 -->
              <tr>
                  <td v-for="header in step(headers)" :key="header.value" :style="{ 'color' : minusCheck(item[header.value].value.middle) ? 'red' : '', 'text-align' : header.align, 'background-color' : 'white' }">
                      {{ replaceSpace(item[header.value].value.middle) }}
                  </td>
              </tr>
              <!-- 3行目 -->
              <tr>
                  <td v-for="header in step(headers)" :key="header.value" :style="{ 'color' : minusCheck(item[header.value].value.bottom) ? 'red' : '', 'text-align' : header.align, 'background-color' : 'white' }">
                      {{ replaceSpace(item[header.value].value.bottom) }}
                  </td>
              </tr>
            </template>
            <template v-slot:no-data>データがありません</template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card :elevation="1">
          <v-data-table class="analysis personal" :headers="this.headers" :items="setIndex" :loading="loading" loading-text="データ取得中" hide-default-header hide-default-footer disable-sort
          :mobile-breakpoint="1200" :page.sync="page" :items-per-page="itemsPerPage" @page-count="pageCount = $event" dense>
            <template slot="top">
              <v-toolbar flat>
                  <v-toolbar-title>{{this.tableName}}</v-toolbar-title>
              </v-toolbar>
              <v-divider/>
            </template>
            <template v-slot:header>
              <thead>
                <tr>
                  <th v-for="header in upperHeaders" :key="header.value" :rowspan="header.row || 1" :colspan="header.col || 1">
                      <div>
                          {{ header.text }}
                      </div>
                  </th>
                </tr>
                <tr>
                  <th v-for="header in bottomHeaders" :key="header.value" :rowspan="header.row || 1" :colspan="header.col || 1">
                      <div>
                          {{ header.text }}
                      </div>
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:item="{ item, headers }">
              <!-- 1行目 -->
              <tr>
                  <td v-for="header in headers" :key="header.displayValue" :style="{'text-align' : header.align, 'background-color' : backgroundColorCheck(item.index) ? 'white' : '#f1f1f1' }" :rowspan="item[header.value].row || 1">
                      <div v-if="header.isStep" :style="{'color' : minusCheck(item[header.value].displayValue.upper) ? 'red' : ''}">
                          {{ replaceSpace(item[header.value].displayValue.upper) }}
                      </div>
                      <div v-else>
                          {{ replaceSpace(item[header.value].displayValue) }}
                      </div>
                  </td>
              </tr>
              <!-- 2行目 -->
              <tr>
                  <td v-for="header in step(headers)" :key="header.displayValue" :style="{ 'color' : minusCheck(item[header.value].displayValue.middle) ? 'red' : '', 'text-align' : header.align, 'background-color' : backgroundColorCheck(item.index) ? 'white' : '#f1f1f1' }">
                      {{ replaceSpace(item[header.value].displayValue.middle) }}
                  </td>
              </tr>
              <!-- 3行目 -->
              <tr>
                  <td v-for="header in step(headers)" :key="header.displayValue" :style="{ 'color' : minusCheck(item[header.value].displayValue.bottom) ? 'red' : '', 'text-align' : header.align, 'background-color' : backgroundColorCheck(item.index) ? 'white' : '#f1f1f1' }">
                      {{ replaceSpace(item[header.value].displayValue.bottom) }}
                  </td>
              </tr>
            </template>
            <template v-slot:no-data>データがありません</template>
            <template v-slot:no-results>検索結果がありません</template>
          </v-data-table>
          <v-divider></v-divider>
          <v-card-actions v-show="pageCount >= 2">
              <v-pagination color="accent" v-model="page" :length="pageCount" total-visible="7" prev-icon="mdi-menu-left" next-icon="mdi-menu-right"></v-pagination>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="searchDialogDrawer" persistent :max-width="width">
          <v-card>
              <v-container>
                <v-card-title class="headline">検索</v-card-title>
                <v-card-text>
                  <v-form ref="search_form" v-model="valid" @submit.prevent>
                    <v-row><v-col cols="12"><header>工期(自)</header></v-col></v-row>
                    <v-row>
                      <v-col :cols="constructionPeriodCol" md="3.5">
                        <v-menu min-width="290px" max-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field label="工期(自) 開始" v-on="on" v-model="startFromFormatted" dense outlined readonly @blur="startDateFrom = parseDate(startFromFormatted)">
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="startDateFrom" no-title scrollable actions locale="ja-jp" :close-on-content-click="true" :day-format="date => new Date(date).getDate()"/>
                        </v-menu>
                      </v-col>
                      <v-col :cols="clearCol" md="2">
                        <v-btn class="mt-1" depressed small color="error" @click.stop="clearRefineField(1)">クリア</v-btn>
                      </v-col>
                      <v-col class="hidden-sm-and-down" cols="auto" md="1" align-self="center" style="margin-bottom: 25px;">〜</v-col>
                      <v-col :cols="constructionPeriodCol" md="3.5">
                        <v-menu min-width="290px" max-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field label="工期(自) 終了" v-on="on" v-model="startToFormatted" dense outlined readonly @blur="startDateTo = parseDate(startToFormatted)">
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="startDateTo" no-title scrollable actions locale="ja-jp" :close-on-content-click="true" :day-format="date => new Date(date).getDate()"/>
                        </v-menu>
                      </v-col>
                      <v-col :cols="clearCol" md="2">
                        <v-btn class="mt-1" depressed small color="error" @click.stop="clearRefineField(2)">クリア</v-btn>
                      </v-col>
                    </v-row>
                    <v-row><v-col cols="12"><header>工期(至)</header></v-col></v-row>
                    <v-row>
                      <v-col :cols="constructionPeriodCol" md="3.5">
                        <v-menu min-width="290px" max-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field label="工期(至) 開始" v-on="on" v-model="endFromFormatted" dense outlined readonly @blur="endDateFrom = parseDate(endFromFormatted)">
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="endDateFrom" no-title scrollable actions locale="ja-jp" :close-on-content-click="true" :day-format="date => new Date(date).getDate()"/>
                        </v-menu>
                      </v-col>
                      <v-col :cols="clearCol" md="2">
                        <v-btn class="mt-1" depressed small color="error" @click.stop="clearRefineField(3)">クリア</v-btn>
                      </v-col>
                      <v-col class="hidden-sm-and-down" cols="auto" md="1" align-self="center" style="margin-bottom: 25px;">〜</v-col>
                      <v-col :cols="constructionPeriodCol" md="3.5">
                        <v-menu min-width="290px" max-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field label="工期(至) 終了" v-on="on" v-model="endToFormatted" dense outlined readonly @blur="endDateTo = parseDate(endToFormatted)">
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="endDateTo" no-title scrollable actions locale="ja-jp" :close-on-content-click="true" :day-format="date => new Date(date).getDate()"/>
                        </v-menu>
                      </v-col>
                      <v-col :cols="clearCol" md="2">
                        <v-btn class="mt-1" depressed small color="error" @click.stop="clearRefineField(4)">クリア</v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed color="grey lighten-1" @click.stop="searchCancelHandler">キャンセル</v-btn>
                    <v-btn depressed color="success" @click.prevent="searchHandler" :disabled="!valid">検索</v-btn>
                </v-card-actions>
              </v-container>
          </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import AnalysisApi from "@/api/analysis-api";
import statusList from "@/helpers/const";
import Rule from "@/validation/rules"
import CalcCommon from "@/helpers/calcCommon";

export default {
  name: "Analysis",
  props: ["user"],
  data: () => ({
    // 文字列検索用
    search: '',

    // 共通コンポーネント: データテーブル関連
    loading: false,

    // ページネーション用
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,

    // 抽出条件
    searchDialogDrawer: false,
    startDateFrom: "",
    startDateTo: "",
    endDateFrom: "",
    endDateTo: "",
    startFromFormatted: "",
    startToFormatted: "",
    endFromFormatted: "",
    endToFormatted: "",

    valid: true,
    constructionDateRules: Rule.constructionDateRules,

    // データ表示部
    tableName: '分析',
    items: [],
    totalItems: [],

    // ヘッダー部
    headers: [],
    upperHeaders: [],
    bottomHeaders: [],
    totalHeaders: [],
    totalUpperHeaders: [],
    totalBottomHeaders: [],
    // カラム幅
    column_width: "200",
    // 集計費目カラム接頭辞
    aggregate_prefix: "aggregate_",
    // 分率接頭辞
    percent_prefix: "percent_",
    // 予算カラム接頭辞
    budget_prefix: "budget_",
    // 実績カラム接頭辞
    achievement_prefix: "achievement_",

    // 検索前
    searchBeforeItems: [],
    searchBeforeTotalItems: [],
    // api結果
    analysis_info: null,
  }),
  created() {
    this.initialize();
  },
  watch: {
    'startDateFrom': function(){
      if (!this.startDateFrom) return;
      if (this.startDateTo && this.startDateTo < this.startDateFrom) {
        this.startDateTo = this.startDateFrom;
      }
      if (this.endDateFrom && this.endDateFrom < this.startDateFrom) {
        this.endDateFrom = this.startDateFrom;
      }
      if (this.endDateTo && this.endDateTo < this.startDateFrom) {
        this.endDateTo = this.startDateFrom;
      }
      this.startFromFormatted = this.formatDate(this.startDateFrom);
    },
    'startDateTo': function(){
      if (!this.startDateTo) return;
      if (this.startDateFrom > this.startDateTo) {
        this.startDateFrom = this.startDateTo;
      }
      if (this.endDateFrom && this.endDateFrom < this.startDateTo) {
        this.endDateFrom = this.startDateTo;
      }
      if (this.endDateTo && this.endDateTo < this.startDateTo) {
        this.endDateTo = this.startDateTo;
      }
      this.startToFormatted = this.formatDate(this.startDateTo);
    },
    'endDateFrom': function(){
      if (!this.endDateFrom) return;
      if (this.startDateFrom > this.endDateFrom) {
        this.startDateFrom = this.endDateFrom;
      }
      if (this.startDateTo > this.endDateFrom) {
        this.startDateTo = this.endDateFrom;
      }
      if (this.endDateTo && this.endDateTo < this.endDateFrom) {
        this.endDateTo = this.endDateFrom;
      }
      this.endFromFormatted = this.formatDate(this.endDateFrom);
    },
    'endDateTo': function(){
      if (!this.endDateTo) return;
      if (this.startDateFrom > this.endDateTo) {
        this.startDateFrom = this.endDateTo;
      }
      if (this.startDateTo > this.endDateTo) {
        this.startDateTo = this.endDateTo;
      }
      if (this.endDateFrom > this.endDateTo) {
        this.endDateFrom = this.endDateTo;
      }
      this.endToFormatted = this.formatDate(this.endDateTo);
    },
  },
  methods: {
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    headerCheck(h) {
      return !this.exclusionHeders.includes(h);
    },
    minusCheck(x) {
      var parsed = parseInt(x);
      if (isNaN(parsed)) { return false; }
      return parsed < 0;
    },
    backgroundColorCheck(index) {
      return index % 2 === 0
    },
    // 日付フォーマット
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}/${month}/${day}`;
    },
    parseDate (date) {
      if (!date) return null;
      const [year,month, day] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    initialize() {
      this.isLoading();
      this.analysisApi = new AnalysisApi();
      const now = new Date();
      // 一年前から当月の月末までをデフォルトに設定
      this.startDateFrom = now.getFullYear() - 1 + "-" + ("00" + (now.getMonth() + 2)).slice(-2) + "-" + "01";
      const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      this.endDateTo = now.getFullYear() + "-" + ("00" + (now.getMonth() + 1)).slice(-2) + "-" + ("00" + (endOfMonth.getDate())).slice(-2);
      const promise = this.analysisApi.info(this.startDateFrom, this.startDateTo, this.endDateFrom, this.endDateTo);
      promise.then(response => {
        this.analysis_info = response.data.body.analysis_info;
        this.headers = this.createHeader(this.analysis_info["aggregate_list"]);
        this.upperHeaders = this.createUpperHeaders();
        this.bottomHeaders = this.createBottomHeaders(this.analysis_info["aggregate_list"]);
        this.totalHeaders = this.createTotalHeader(this.analysis_info["aggregate_list"]);
        this.totalUpperHeaders = this.createTotalUpperHeaders();
        this.totalBottomHeaders = this.createTotalBottomHeaders(this.analysis_info["aggregate_list"]);
        var data = this.createData(this.analysis_info["construction_list"], this.analysis_info["aggregate_list"], this.analysis_info["budget_list"], this.analysis_info["report_list"]);
        this.items = data["baseData"];
        this.searchBeforeItems = data["baseData"];
        this.totalItems = data["totalData"];
        this.searchBeforeTotalItems = data["totalData"];
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error", error.response.data.message);
            this.$router.push({ name: "Dashboard" });
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
     // ヘッダー設定
    createHeader(aggregates) {
      var result = [
        { text: "工番", value: "construction_number", align: "left", isStep: false },
        { text: "監督者", value: "management_user_name", align: "left", isStep: false },
        { text: "工事名", value: "construction_name", align: "left", isStep: false },
        { text: "受注先", value: "order_name", align: "left", isStep: false },
        { text: "工期", value: "construction_date", align: "center", isStep: true },
        { text: "請負金額", value: "estimated_price", align: "right", isStep: false, filterable: false },
        { text: "", value: "division", align: "center", isStep: true, filterable: false },
        { text: "経費合計", value: "total", align: "right", isStep: true, filterable: false },
        { text: "粗利", value: "profitability", align: "right", isStep: true, filterable: false },
        { text: "粗利率", value: "profitability_percent", align: "right", isStep: true, filterable: false }
      ];
      // 集計費目
      for (var aggregate of aggregates) {
        result.push({ text: aggregate.name, value: this.aggregate_prefix + aggregate.id +  '_left', align: "right", isStep: true, filterable: false });
        result.push({ text: aggregate.name, value: this.percent_prefix + aggregate.id + '_right', align: "right", isStep: true, filterable: false });
      }

      return result;
    },
    createUpperHeaders() {
      var result = [
        { text: "工番", value: "construction_number", align: "left", row: 2 },
        { text: "監督者", value: "management_user_name", align: "left", row: 2 },
        { text: "工事名", value: "construction_name", align: "left", row: 2 },
        { text: "受注先", value: "order_name", align: "left", row: 2 },
        { text: "工期", value: "construction_date", align: "left", row: 2 },
        { text: "請負金額", value: "estimated_price", align: "right", row: 2 },
        { text: "", value: "division", align: "center", row: 2 },
        { text: "経費合計", value: "total", align: "right", row: 2 },
        { text: "粗利", value: "profitability", align: "right", row: 2 },
        { text: "粗利率", value: "profitability_percent", align: "right", row: 2 },
        { text: "経費内訳", value: "", align: "right", col: 20 }
      ];
      return result;
    },
    createBottomHeaders(aggregates) {
      var result = [];
      // 集計費目
      for (var aggregate of aggregates) {
        result.push({ text: aggregate.name, value: this.aggregate_prefix + aggregate.id, align: "right", col: 2 });
      }
      return result;
    },
    createTotalHeader(aggregates) {
      var result = [];
      result.push({ text: "", value: "explanation", align: "center", isStep: false });
      result.push({ text: "請負金額", value: "estimated_price", align: "right", isStep: false });
      result.push({ text: "", value: "division", align: "center", isStep: true });
      result.push({ text: "経費合計", value: "total", align: "right", isStep: true });
      result.push({ text: "粗利", value: "profitability", align: "right", isStep: true });
      result.push({ text: "粗利率", value: "profitability_percent", align: "right", isStep: true });
      // 集計費目
      for (var aggregate of aggregates) {
        result.push({ text: aggregate.name, value: this.aggregate_prefix + aggregate.id, align: "right", isStep: true });
        result.push({ text: aggregate.name, value: this.percent_prefix + aggregate.id, align: "right", isStep: true });
      }

      return result;
    },
    createTotalUpperHeaders() {
      var result = [
        { text: "", value: "explanation", align: "center", row: 2 },
        { text: "請負金額", value: "estimated_price", align: "right", row: 2 },
        { text: "", value: "division", align: "center", row: 2 },
        { text: "経費合計", value: "total", align: "right", row: 2 },
        { text: "粗利", value: "profitability", align: "right", row: 2 },
        { text: "粗利率", value: "profitability_percent", align: "right", row: 2 },
        { text: "経費内訳", value: "", align: "right", col: 20 }
      ];
      return result;
    },
    createTotalBottomHeaders(aggregates) {
      var result = [];
      // 集計費目
      for (var aggregate of aggregates) {
        result.push({ text: aggregate.name, value: this.aggregate_prefix + aggregate.id, align: "right", col: 2 });
      }
      return result;
    },

    // データ作成
    createData(constructions, aggregates, budgets, reports) {
      var baseData = [];
      var totalData = [];

      var baseRow = {};
      for (var header of this.headers) {
        baseRow[header.value] = null;
      }

      var totalBaseData = [];
      for (var construction of constructions) {
        var totalRow = {};

        // 実行予算
        var budget_list = budgets.filter(item => { return item.construction_id === construction.construction_id });
        var budget_data = this.createBudgetData(aggregates, budget_list)
        // 実績
        var report_list = reports.filter(item => { return item.construction_id === construction.construction_id  });
        var achievement_data = this.createAchievementData(aggregates, report_list)
        // 実行予算合計
        var budget_total_price = budget_data.reduce((prev, current) => { return { value: prev.value + current.value } }).value;
        // 実績合計
        var achievement_total_price = achievement_data.reduce((prev, current) => { return { value: prev.value + current.value } }).value;
        // 実行予算粗利益
        var b_profitability = construction.estimated_price - budget_total_price;
        // 実績粗利益
        var a_profitability = construction.estimated_price - achievement_total_price;

        totalRow["budget_total_price"] = budget_total_price;
        totalRow["achievement_total_price"] = achievement_total_price;
        totalRow["estimated_price"] = construction.estimated_price;

        // 予算行
        for (var budget of budget_data) {
          totalRow[this.budget_prefix + budget.name] = budget.value;
        }
        // 原価行
        for (var achievement of achievement_data) {
          totalRow[this.achievement_prefix + achievement.name] = achievement.value;
        }

        var row = Object.assign({}, baseRow);
        row['construction_number'] = { row: 3, value: construction.construction_number, displayValue: construction.construction_number };
        row['management_user'] = { row: 3, value: construction.management_user_name , displayValue: construction.management_user_name };
        row["management_user_name"] = { row: 3, value: construction.management_user_name, displayValue: construction.management_user_name };
        row["construction_name"] = { row: 3, value: construction.construction_name, displayValue: construction.construction_name };
        row["order_name"] = { row: 3, value: construction.order_name, displayValue: construction.order_name };
        row['construction_date'] = { value: construction.start_date, displayValue: { upper: construction.start_date, middle: "〜", bottom: construction.end_date } };
        row["estimated_price"] = { row: 3, value: "", displayValue: CalcCommon.addFigure(construction.estimated_price) };
        row["division"] = { value: "", displayValue: { upper: "予算", middle: "実績", bottom: "予実差" } };
        // 経費合計
        var expense_total = achievement_total_price - budget_total_price;
        row['total'] = { value: "", displayValue: { upper: CalcCommon.addFigure(budget_total_price), middle: CalcCommon.addFigure(achievement_total_price), bottom: CalcCommon.addFigure(expense_total) } };
        // 粗利
        var profitability = a_profitability - b_profitability;
        row['profitability'] = { value: "", displayValue: { upper: CalcCommon.addFigure(b_profitability), middle: CalcCommon.addFigure(a_profitability), bottom: CalcCommon.addFigure(profitability) } };
        // 粗利率
        var profitability_percent_upper = this.calcProfitabilityPercent(construction.estimated_price, b_profitability);
        var profitability_percent_middle = this.calcProfitabilityPercent(construction.estimated_price, a_profitability);
        var profitability_percent_bottom = profitability_percent_middle - profitability_percent_upper;
        row['profitability_percent'] = { value: "", displayValue: { upper: profitability_percent_upper + "%", middle: profitability_percent_middle + "%", bottom: profitability_percent_bottom + "%" } };

        for (var aggregate of aggregates) {
          var aggregateLeftName = this.aggregate_prefix + aggregate.id + '_left';
          var aggregateRightName = this.percent_prefix + aggregate.id + '_right';
          // 予算
          var budgetItem = budget_data.filter(item => { return item.name === this.aggregate_prefix + aggregate.id });
          var budgetPercent = this.calcProfitabilityPercent(budget_total_price, budgetItem[0].value);
          // 実績
          var achievementItem = achievement_data.filter(item => { return item.name === this.aggregate_prefix + aggregate.id });
          var achievementPercent = this.calcProfitabilityPercent(achievement_total_price, achievementItem[0].value);
          // 予実差
          var forecastDiff = achievementItem[0].value - budgetItem[0].value;
          var forecastDiffPercent = (achievementPercent - budgetPercent);

          row[aggregateLeftName] = { value: "", displayValue: { upper: CalcCommon.addFigure(budgetItem[0].value), middle: CalcCommon.addFigure(achievementItem[0].value), bottom: CalcCommon.addFigure(forecastDiff) } };
          row[aggregateRightName] = { value: "", displayValue: { upper: budgetPercent + "%", middle: achievementPercent + "%", bottom: forecastDiffPercent  + "%"} };
        }

        baseData.push(row);
        totalBaseData.push(totalRow);
      }

      if (constructions.length > 0) {
        var temp = {};
        for (var data of totalBaseData) {
          for(var tmpKey in data) {
            if (!(tmpKey in temp)) {
              temp[tmpKey] = 0;
            }
            temp[tmpKey] += data[tmpKey];
          }
        }

        // 金額計算
        var estimatedPrice = 0;
        var budgetTotal = 0;
        var achievementTotal = 0;
        var key = "";
        var keyStr = "";
        var workBudget = {};
        var workAchievement = {};

        for (key in temp) {
          if (key == "estimated_price") {
            estimatedPrice = temp[key];
          } else if (key.includes(this.budget_prefix + this.aggregate_prefix)) {
            budgetTotal += temp[key];
            keyStr = key.replace(this.budget_prefix, '');
            workBudget[keyStr] = temp[key];
          } else if (key.includes(this.achievement_prefix + this.aggregate_prefix)) {
            achievementTotal += temp[key];
            keyStr = key.replace(this.achievement_prefix, '');
            workAchievement[keyStr] = temp[key];
          }

          var forecastTotalDiff = workAchievement[keyStr] - workBudget[keyStr];
          totalRow[keyStr] = { value: { upper: CalcCommon.addFigure(workBudget[keyStr]), middle: CalcCommon.addFigure(workAchievement[keyStr]), bottom: CalcCommon.addFigure(forecastTotalDiff) } };
        }

        // 粗利率計算
        keyStr = "";
        var workBudgetPercent = {};
        var workAchievementPercent = {};

        for (key in temp) {
          if (key.includes(this.budget_prefix + this.aggregate_prefix)) {
            keyStr = key.replace(this.budget_prefix + this.aggregate_prefix, this.percent_prefix);
            workBudgetPercent[keyStr] = this.calcProfitabilityPercent(budgetTotal, temp[key]);
          } else if (key.includes(this.achievement_prefix + this.aggregate_prefix)) {
            keyStr = key.replace(this.achievement_prefix + this.aggregate_prefix, this.percent_prefix);
            workAchievementPercent[keyStr] = this.calcProfitabilityPercent(achievementTotal, temp[key]);
          }

          var forecastTotalPercentDiff = workAchievementPercent[keyStr] - workBudgetPercent[keyStr];
          totalRow[keyStr] = { value: { upper: workBudgetPercent[keyStr] + "%", middle: workAchievementPercent[keyStr] + "%", bottom: forecastTotalPercentDiff + "%" } };
        }

        var budgetTotal2 = budgetTotal;
        var achievementTotal2 = achievementTotal;
        var totalDiff = (achievementTotal2 - budgetTotal2);
        var budgetTotalProfitability = estimatedPrice - budgetTotal;
        var achievementTotalProfitability = estimatedPrice - achievementTotal;
        var ProfitabilityDiff = achievementTotalProfitability - budgetTotalProfitability;
        var budgetTotalPercent = this.calcProfitabilityPercent(estimatedPrice, (estimatedPrice - budgetTotal));
        var achievementTotalPercent = this.calcProfitabilityPercent(estimatedPrice, (estimatedPrice - achievementTotal));
        var percentDiff = achievementTotalPercent - budgetTotalPercent;

        totalRow["explanation"] = { row: 3, value: "総計" };
        totalRow["estimated_price"] = { row: 3, value: CalcCommon.addFigure(estimatedPrice) };
        totalRow["division"] = { value: { upper: "予算", middle: "実績", bottom: "予実差" } };
        totalRow["total"] = { value: { upper: CalcCommon.addFigure(budgetTotal2), middle: CalcCommon.addFigure(achievementTotal2), bottom: CalcCommon.addFigure(totalDiff) } };
        totalRow["profitability"] = { value: { upper: CalcCommon.addFigure(budgetTotalProfitability), middle: CalcCommon.addFigure(achievementTotalProfitability), bottom: CalcCommon.addFigure(ProfitabilityDiff) } };
        totalRow["profitability_percent"] = { value: { upper: budgetTotalPercent + "%", middle: achievementTotalPercent + "%", bottom: percentDiff + "%" } };

        totalData.push(totalRow);
      }

      return {
        baseData: baseData,
        totalData: totalData
      };
    },

    calcProfitabilityPercent(denominator, numerator) {
      if (denominator <= 0) {
        return 0;
      }
      var result = Math.floor((numerator/denominator)*100);
      if (result < 0) {
        result = 0;
      }
      return result;
    },

    // 実行予算データ作成
    createBudgetData(aggregates, budget_list) {
      var result = [];

      var items = [];
      for (var budget of budget_list) {
        for (var item of budget.tree_data.row) {
          this.reducePrice(item, items);
        }
      }

      for (var aggregate of aggregates) {
        var row = {};
        row["name"] = this.aggregate_prefix + aggregate.id;
        row["percent_name"] = this.percent + aggregate.id;
        row["value"] = items.filter(
          item => { return item.aggregate.value === aggregate.id }
        ).reduce((prev, current) => {
          return prev + Number(current.price);
        }, 0);
        result.push(row);
      }

      return result;
    },
    reducePrice(object, result) {
      if (object.children.length > 0) {
        for (var child of object.children) {
          this.reducePrice(child, result);
        }
      }
      if (object.data.items.length > 0) {
        for (var item of object.data.items) {
          result.push(item);
        }
      }
    },

    // 実績データ作成
    createAchievementData(aggregates, report_list) {
      var result = [];

      for (var aggregate of aggregates) {
        var row = {};
        var price = 0;
        if (aggregate.flg) {
          // 労務費
          for (var work_item of report_list) {
            var cost_data = work_item.report.employmentCostDataTable;
            for (var cost of cost_data) {
              if ('aggregate' in cost) {
                if (cost.aggregate == null || aggregate.name != cost.aggregate.name) {
                  continue;
                }
                price = price + Number(cost.workPrice);
              }
            }
          }
        } else {
          // その他
          for (var other_item of report_list) {
            if (aggregate.name in other_item.report.expenseTableData) {
              var expense_data = other_item.report.expenseTableData[aggregate.name];
              for (var expense of expense_data) {
                price = price + Number(expense.price);
              }
            }
          }
        }
        row["name"] = this.aggregate_prefix + aggregate.id;
        row["percent_name"] = this.percent + aggregate.id;
        row["value"] = price;
        result.push(row);
      }

      return result;
    },

    // 検索条件
    searchHandler() {
      this.search = "";
      this.isLoading();
      if (this.$refs.search_form) {
        this.$refs.search_form.resetValidation();
      }
      const promise = this.analysisApi.info(this.startDateFrom, this.startDateTo, this.endDateFrom, this.endDateTo);
      promise.then(response => {
        this.analysis_info = response.data.body.analysis_info;
        var data = this.createData(this.analysis_info["construction_list"], this.analysis_info["aggregate_list"], this.analysis_info["budget_list"], this.analysis_info["report_list"]);
        this.items = data["baseData"];
        this.searchBeforeItems = data["baseData"];
        this.totalItems = data["totalData"];
        this.searchBeforeTotalItems = data["totalData"];
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error", error.response.data.message);
            this.$router.push({ name: "Dashboard" });
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
      this.searchCancelHandler()
    },
    searchCancelHandler() {
      this.searchDialogDrawer = false;
    },
    clearRefineField(idx) {
      switch (idx) {
        case 1: // 工期(自) 開始
          this.startDateFrom = "";
          this.startFromFormatted = "";
          break;
        case 2: // 工期(自) 終了
          this.startDateTo = "";
          this.startToFormatted = "";
          break;
        case 3: // 工期(至) 開始
          this.endDateFrom = "";
          this.endFromFormatted = "";
          break;
        case 4: // 工期(至) 終了
          this.endDateTo = "";
          this.endToFormatted = "";
          break;
      }
    },
    replaceSpace(displayValue) {
      var result = displayValue;
      var str = String(displayValue);
      if ( str.indexOf("%") !== -1 ) {
        str = str.slice(0,-1);
      }
      if ( str == "0" ) {
        result = "";
      }
      return result;
    },
    textSearch: function(searchText) {
      if(!searchText){
        this.items = this.searchBeforeItems;
        this.totalItems = this.searchBeforeTotalItems;
      }
      else{
          const list = [
            "construction_number",
            "management_user_name",
            "construction_name",
            "order_name",
            "start_date",
            "end_date"
          ];
          const construction_list = this.analysis_info["construction_list"];
          const searchAfterConstructionList = construction_list.filter(function(items){
            var flag = false
            Object.keys(items).forEach(function(key){
              if (list.includes(key)) {
                if(items[key]){
                  // 検索文字列
                  var str = String(searchText);
                  // 検索対象列の文字列
                  var itemValueStr = String(items[key]);
                  if (itemValueStr.indexOf(str) !== -1) {
                    flag = true
                  }
                }
              }
            });
            return flag;
          });
          var data = this.createData(searchAfterConstructionList, this.analysis_info["aggregate_list"], this.analysis_info["budget_list"], this.analysis_info["report_list"]);
          this.items = data["baseData"];
          this.totalItems = data["totalData"];
          return true;
      }
    }
  },
  computed: {
    step: function() {
        return function(headers) { return headers.filter(e => e.isStep) }
    },
    setIndex () {
      return this.items.map((item, index)=> {
        item.index= index;
        return item;
      })
    },
    constructionPeriodCol: function() {
      var result = 'auto'
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          result = '7'
          return result;
        case 'sm':
          result = '7'
          return result;
        case 'md':
          result = 'auto'
          return result;
        case 'lg':
          result = 'auto'
          return result;
        case 'xl':
          result = 'auto'
          return result;
      }
      return result
    },
    clearCol: function() {
      var result = 'auto'
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          result = '5'
          return result;
        case 'sm':
          result = '5'
          return result;
        case 'md':
          result = 'auto'
          return result;
        case 'lg':
          result = 'auto'
          return result;
        case 'xl':
          result = 'auto'
          return result;
      }
      return result
    },
    width: function() {
      var result = '800'
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          result = '500'
          return result;
        case 'sm':
          result = '500'
          return result;
        case 'md':
          result = '900'
          return result;
        case 'lg':
          result = '900'
          return result;
        case 'xl':
          result = '900'
          return result;
      }
      return result
    },
  }
};
</script>

<style lang="scss">
.analysis table thead tr th { text-align: center !important; }

.analysis table { border-top:1px solid #8b8b8b; }
.analysis table th { background-color: #dddddd; }
.analysis table th + th { border-left:1px solid #8b8b8b; border-bottom:1px solid #8b8b8b; }
.analysis table thead tr:first-child th { border-left:1px solid #8b8b8b; border-bottom:1px solid #8b8b8b !important; }
.analysis table thead tr:last-child th { border-left:1px solid #8b8b8b;  border-bottom:1px solid #8b8b8b !important; }
.analysis table td + td { border-left:1px solid #8b8b8b; border-bottom:1px solid #8b8b8b; }
.analysis table tbody tr:not(:first-child) td:not(.v-data-table__mobile-row) { border-left:1px solid #8b8b8b; border-bottom:1px solid #8b8b8b !important; }
.analysis table tbody tr:not(:last-child) td:not(.v-data-table__mobile-row) { border-left:1px solid #8b8b8b; border-bottom:1px solid #8b8b8b !important; }

.personal .v-data-table__wrapper { overflow-x: scroll; transform: rotateX(180deg) !important; }
.personal table { transform: rotateX(180deg) !important; }

</style>

